import React, { useState, useEffect, Children } from 'react'
import SidebarProposal from '../../layouts/sidebarProposal/SidebarProposal'
import ErrorWidget from '../../widgets/errorWidget/ErrorWidget'
import PanalLoadingTemplate from '../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { startLoading, doneLoading } from '../../utils/loading'
import ContentHeader from '../../components/ContentHeader/ContentHeader'
import { getAssessmentReportPage } from '../../redux/actions/assessment'
import AssessmentReportDynamicWidgets from '../../widgets/assessment/AssessmentReportDynamicWidgets'
import AssessmentReportUnitCompetencyWidgets from '../../widgets/assessment/AssessmentReportUnitCompetencyWidgets'

export default function ReportUnitCompetency() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()

    try {
      const response = await getAssessmentReportPage(6, 1, 5)
      // console.log('response', response)
      setSchema(response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }

    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isAssessment>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isAssessment>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isAssessment>
      <ContentHeader header={schema.header} isNotCallApi />
      {schema && <AssessmentReportUnitCompetencyWidgets schema={schema} type={6} />}
    </SidebarProposal>
  )
}
